import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {Budget} from '../../interfaces';
import {Subject} from 'rxjs';
import {DataService} from '../../services/data.service';
import {debounceTime, distinctUntilChanged, map, take, takeUntil} from 'rxjs/operators';
import {MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';



@Component({
    selector: 'app-project-selector-component',
    templateUrl: './project-selector-component.component.html',
    imports: [
        MatFormField,
        MatAutocomplete,
        MatLabel,
        MatOption,
        MatInput,
        ReactiveFormsModule,
        MatAutocompleteTrigger
    ],
    styleUrls: ['./project-selector-component.component.scss']
})
export class ProjectSelectorComponent implements OnDestroy {

    formControl: UntypedFormControl = new UntypedFormControl(null);

    @Input() exportOnly = false;
    @Input() importOnly = true;
    @Input() required: boolean;
    @Output() validityChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() budgetChange: EventEmitter<Budget | null> = new EventEmitter<Budget | null>();

    budgetsList: Budget[];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(
        private dataService: DataService
    ) {
        this.formControl.statusChanges.pipe(
            takeUntil(this.unsubscribe$),
            map(v => v === 'VALID')
        ).subscribe(this.validityChange);

        this.formControl.valueChanges.pipe(
            debounceTime(150),
            distinctUntilChanged(),
            takeUntil(this.unsubscribe$),
            map(v => typeof v === 'object' ? v : null),
            map(v => {
                this.dataService.getOpenProjectsList()
                    .pipe(
                        take(1),
                        map((bs) => {
                            if (this.exportOnly) return bs.filter(b => b.export);
                            if (this.importOnly) return bs.filter(b => !b.export);
                            return bs;
                        }))
                    .subscribe(result => {
                        this.budgetsList = result.filter(b => b.project?.projectNr?.includes(this.formControl.value));
                    });
                return v;
            })
        ).subscribe(this.budgetChange);
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    displayFn(budget: Budget) {
        return budget ? budget.project.projectNr : '';
    }
}
